module.exports = __webpack_public_path__ + "static/img/planet3.95a568a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/he/planet/planet3.png
// module id = 5MPU
// module chunks = 1